var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentsTrack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 700,
    viewBox: "0 0 1200 700",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1200,
    y2: 700,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBFFB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1F79A"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 1200,
    height: 700,
    rx: 48,
    fill: "url(#bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 170,
    width: 860,
    height: 360,
    rx: 44,
    fill: "#FFFFFF",
    opacity: 0.95
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 245,
    width: 320,
    height: 44,
    rx: 22,
    fill: "#F3F5FA"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 320,
    width: 620,
    height: 22,
    rx: 11,
    fill: "#E6EAF3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 360,
    width: 560,
    height: 22,
    rx: 11,
    fill: "#E6EAF3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 400,
    width: 480,
    height: 22,
    rx: 11,
    fill: "#E6EAF3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 265,
    r: 36,
    fill: "#171F34",
    opacity: 0.08
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 900,
    cy: 265,
    r: 26,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 251v18",
    stroke: "#171F34",
    strokeWidth: 8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M900 265h14",
    stroke: "#171F34",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("path", {
    d: "M320 560c70-80 150-115 260-115 160 0 250 120 395 120",
    stroke: "#D7DDEA",
    strokeWidth: 18,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 320,
    cy: 560,
    r: 18,
    fill: "#FCB402"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580,
    cy: 445,
    r: 18,
    fill: "#FCB402"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 975,
    cy: 565,
    r: 18,
    fill: "#FCB402"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsTrack);
export default __webpack_public_path__ + "static/media/payments-track.9e9c4c4b6d7a9ed64c6942f041d8c85d.svg";
export { ForwardRef as ReactComponent };